module.exports = __webpack_public_path__ + "img/logo-icon-white.a4abe258.png";